var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-status f12 fw500",class:_vm.status},[_vm._v(" "+_vm._s(_vm.status !== 'test' ? _vm.statusText : '-')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }